enum UserActionTypes {
  ADD_USER = "ADD_USER",
  ADD_TYPE = "ADD_TYPE",
}

export default UserActionTypes
